module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-dark.a57b85c12c21179f09b682bca3597a4f.svg";